




















































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import SkriningGiziLanjutService from "@/services/SkriningGiziLanjut";
import AsesmenAwalRanapMedisStore from "@/store/modules/AsesmenAwalRanapMedisStore";
import TimeStamp from "@/components/pemeriksaan/assesmen/TimeStamp.vue";
import moment from "moment";

@Component({
  components: {
    TimeStamp
  },
  inject: { isReadOnly: { default: () => () => false } }
})
export default class CardSkriningGiziLanjut extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  @Prop() value!: object; // v-model for edit item

  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  valid = true;
  saving = false;

  // Form fields
  id: number = null;
  metodeImt = "pengukuran_langsung";
  beratBadan: number = null;
  tinggiBadan: number = null;
  lingkarLenganAtas: number = null;
  diagnosisMedis = "";
  skorImt: number = null;
  skorKehilanganBb: number = null;
  skorEfekPenyakit: number = null;
  tindakLanjut = "";
  examinedAt = moment().format("YYYY-MM-DD HH:mm:ss");

  get maxDate() {
    return moment().format("YYYY-MM-DD");
  }

  get sessLogin() {
    return userModule.user;
  }

  // IMT auto-calculation
  get imtComputed(): number | null {
    if (this.metodeImt === "pengukuran_langsung") {
      if (this.beratBadan > 0 && this.tinggiBadan > 0) {
        const tbMeter = this.tinggiBadan / 100;
        return this.beratBadan / (tbMeter * tbMeter);
      }
    } else if (this.metodeImt === "estimasi_lla") {
      if (this.lingkarLenganAtas > 0) {
        return (1.1 * this.lingkarLenganAtas) - 6.7;
      }
    }
    return null;
  }

  // Auto-suggest skor IMT
  get suggestedSkorImt(): number | null {
    if (this.imtComputed === null) return null;
    if (this.imtComputed > 20) return 0;
    if (this.imtComputed >= 18.5) return 1;
    return 2;
  }

  // Auto-suggest on IMT change (only when user hasn't manually selected)
  imtSuggestionApplied = false;

  @Watch("imtComputed")
  onImtChanged() {
    if (this.suggestedSkorImt !== null && !this.imtSuggestionApplied) {
      this.skorImt = this.suggestedSkorImt;
    }
  }

  @Watch("skorImt")
  onSkorImtManualChange() {
    // If user manually changes skor_imt to something different from suggestion, stop auto-suggesting
    if (this.suggestedSkorImt !== null && this.skorImt !== this.suggestedSkorImt) {
      this.imtSuggestionApplied = true;
    }
  }

  // Total skor
  get totalSkor(): number | null {
    if (this.skorImt === null || this.skorKehilanganBb === null || this.skorEfekPenyakit === null) {
      return null;
    }
    return this.skorImt + this.skorKehilanganBb + this.skorEfekPenyakit;
  }

  // Kategori risiko
  get kategoriRisiko(): string | null {
    if (this.totalSkor === null) return null;
    if (this.totalSkor === 0) return "rendah";
    if (this.totalSkor === 1) return "menengah";
    return "tinggi";
  }

  get kategoriColor(): string {
    if (this.kategoriRisiko === "rendah") return "green";
    if (this.kategoriRisiko === "menengah") return "orange";
    if (this.kategoriRisiko === "tinggi") return "red";
    return "grey";
  }

  get kategoriText(): string {
    if (this.kategoriRisiko === "rendah") return "RISIKO RENDAH (Skor 0)";
    if (this.kategoriRisiko === "menengah") return "RISIKO MENENGAH (Skor 1)";
    if (this.kategoriRisiko === "tinggi") return `RISIKO TINGGI (Skor ${this.totalSkor})`;
    return "";
  }

  get kategoriAlertType(): string {
    if (this.kategoriRisiko === "rendah") return "success";
    if (this.kategoriRisiko === "menengah") return "warning";
    if (this.kategoriRisiko === "tinggi") return "error";
    return "info";
  }

  get interpretasiText(): string {
    if (this.kategoriRisiko === "rendah") {
      return "Berisiko rendah — Ulangi skrining setiap 7 hari";
    }
    if (this.kategoriRisiko === "menengah") {
      return "Risiko menengah — Monitoring asupan selama 3 hari, jika tidak ada peningkatan lanjutkan pengkajian. Ulangi skrining setiap 7 hari";
    }
    if (this.kategoriRisiko === "tinggi") {
      return "Berisiko tinggi — Bekerjasama dengan tim dukungan gizi/panitia asuhan nutrisi, upayakan peningkatan asupan gizi dan berikan makanan sesuai daya terima. Monitoring asupan makanan setiap hari. Ulangi skrining setiap 7 hari";
    }
    return "";
  }

  // Watch v-model for edit
  @Watch("value")
  onValueChange(val) {
    if (val) {
      this.populateForm(val);
    }
  }

  populateForm(item) {
    this.id = item.id;
    this.metodeImt = item.metode_imt;
    this.beratBadan = item.berat_badan;
    this.tinggiBadan = item.tinggi_badan;
    this.lingkarLenganAtas = item.lingkar_lengan_atas;
    this.diagnosisMedis = item.diagnosis_medis;
    this.imtSuggestionApplied = true; // Don't auto-suggest when editing
    this.skorImt = item.skor_imt;
    this.skorKehilanganBb = item.skor_kehilangan_bb;
    this.skorEfekPenyakit = item.skor_efek_penyakit;
    this.tindakLanjut = item.tindak_lanjut || "";
    this.examinedAt = item.examined_at || moment().format("YYYY-MM-DD HH:mm:ss");
  }

  mounted() {
    if (!this.value) {
      this.prefillFromAsesmen();
    }
  }

  prefillFromAsesmen() {
    const asesmen = AsesmenAwalRanapMedisStore.asesmen;
    if (!asesmen) return;

    if (asesmen.antropometri) {
      if (asesmen.antropometri.berat_badan) {
        this.beratBadan = parseFloat(String(asesmen.antropometri.berat_badan));
      }
      if (asesmen.antropometri.tinggi_badan) {
        this.tinggiBadan = parseFloat(String(asesmen.antropometri.tinggi_badan));
      }
    }

    if (asesmen.diagnosis) {
      this.diagnosisMedis = asesmen.diagnosis;
    }
  }

  setTime(val) {
    this.examinedAt = val;
  }

  get sendData() {
    return {
      register_id: this.register,
      pasien_rm: this.rm,
      berat_badan: this.beratBadan,
      tinggi_badan: this.tinggiBadan,
      imt: this.imtComputed ? parseFloat(this.imtComputed.toFixed(1)) : 0,
      lingkar_lengan_atas: this.metodeImt === "estimasi_lla" ? this.lingkarLenganAtas : null,
      metode_imt: this.metodeImt,
      diagnosis_medis: this.diagnosisMedis,
      skor_imt: this.skorImt,
      skor_kehilangan_bb: this.skorKehilanganBb,
      skor_efek_penyakit: this.skorEfekPenyakit,
      total_skor: this.totalSkor,
      kategori_risiko: this.kategoriRisiko,
      tindak_lanjut: this.tindakLanjut || null,
      examined_at: this.examinedAt
    };
  }

  save() {
    if (this.readOnly) return;
    if ((this.$refs.form as any).validate()) {
      if (this.imtComputed === null || this.imtComputed <= 0) {
        appModule.NoticeDelay("IMT belum dapat dihitung. Pastikan data antropometri sudah lengkap.");
        return;
      }

      this.saving = true;

      const action = this.id
        ? SkriningGiziLanjutService.update(this.id, this.sendData)
        : SkriningGiziLanjutService.create(this.sendData);

      action
        .then(resp => {
          if (resp.data) {
            appModule.NoticeDelay(
              this.id
                ? "Skrining Gizi Lanjut berhasil diubah"
                : "Skrining Gizi Lanjut berhasil disimpan"
            );
            this.resetForm();
            this.$emit("saved");
          }
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }

  resetForm() {
    this.id = null;
    this.metodeImt = "pengukuran_langsung";
    this.beratBadan = null;
    this.tinggiBadan = null;
    this.lingkarLenganAtas = null;
    this.diagnosisMedis = "";
    this.skorImt = null;
    this.skorKehilanganBb = null;
    this.skorEfekPenyakit = null;
    this.tindakLanjut = "";
    this.examinedAt = moment().format("YYYY-MM-DD HH:mm:ss");
    this.imtSuggestionApplied = false;
    this.$emit("input", null);

    if (this.$refs.form) {
      (this.$refs.form as any).resetValidation();
    }

    this.prefillFromAsesmen();
  }
}
